import { getTranslation } from '@easy-expense/intl-client';
import { theme } from '@easy-expense/ui-theme';
import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';
import React from 'react';

import { ReconciledStatementRow } from './reconcile';

export const ReconciliationSummaryStats: React.FC<{
  reconciledStatement: ReconciledStatementRow[];
  totalHeader: string;
}> = ({ reconciledStatement }) => {
  const reconciledCount = reconciledStatement.filter((r) => r.Status === 'Reconciled').length;
  const missingCount = reconciledStatement.filter((r) => r.Status === 'Missing').length;

  return (
    <Layout.Column
      bg="inputBackground"
      px={16}
      py={16}
      radius={8}
      border={[1, 'solid', 'inputBorder']}
      style={{ maxWidth: 300 }}
    >
      <OpenSans.Primary size={18} weight="bold-700">
        {getTranslation('Summary')}
      </OpenSans.Primary>

      <Spacer.Vertical size={8} />

      <Layout.Row justify="space-between">
        <OpenSans.Secondary size={16}>{getTranslation('Reconciled')}:</OpenSans.Secondary>
        <OpenSans.Primary size={16} weight="bold-700" style={{ color: theme.colors.success }}>
          {reconciledCount}
        </OpenSans.Primary>
      </Layout.Row>

      <Spacer.Vertical size={8} />

      <Layout.Row justify="space-between">
        <OpenSans.Secondary size={16}>{getTranslation('Missing')}:</OpenSans.Secondary>
        <OpenSans.Primary size={16} weight="bold-700" style={{ color: theme.colors.destructive }}>
          {missingCount}
        </OpenSans.Primary>
      </Layout.Row>
    </Layout.Column>
  );
};
